import apiService from 'src/enviroment';

// eslint-disable-next-line import/prefer-default-export
const segmentacionService = {
  getCountrys: async () => {
    try {
      const { status, data } = await apiService.get('/segmentacion/paises/');
      if (status === 200 && data.success === 1) {
        return data.data;
      }
      return false;
    } catch (error) {
      return false;
    }
  },
  getSegmentacion: async () => {
    try {
      const response = await apiService.get(
        '/segmentacion/maestros/segmentacion/',
      );
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  getEmpresas: async () => {
    try {
      const response = await apiService.get('/segmentacion/empresas/');
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  getCategorias: async () => {
    try {
      const response = await apiService.get('/segmentacion/categorias/');
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  getSubCategorias: async (id) => {
    try {
      const response = await apiService.get(
        `/segmentacion/subcategorias/?categoria_id=${id}`,
      );
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  getSegmentos: async (id) => {
    try {
      const response = await apiService.get(
        `/segmentacion/segmentos/?subcategoria_id=${id}`,
      );
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  getSubSegmentos: async (id) => {
    try {
      const response = await apiService.get(
        `/segmentacion/subsegmentos/?segmento_id=${id}`,
      );
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  putSegmento: async (params) => {
    const body = {
      uuid: params.uuid,
      empresa: params.empresa,
      marca: params.marca,
      linea: params.linea,
      carroceria: params.carroceria,
      combustible: params.combustible,
      clase: params.clase,
      categoria: params.categoria,
      subcategoria: params.subcategoria,
      segmento: params.segmento,
      subsegmento: params.subsegmento,
      pais_origen: params.pais,
      ensambladora: params.ensambladora,
    };

    try {
      const { status, data } = await apiService.put(
        '/segmentacion/maestros/segmentacion/',
        body,
      );
      if (status === 200 && data.success === 1) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  },
  deleteSegmento: (uuid) => apiService.put(
    `/segmentacion/maestros/segmentacion/?uuid_origen=leo&uuid_destino=${uuid}`,
  ),
  createSegmento: (body) => apiService.post('/segmentacion/maestros/segmentacion/', body),
};

export default segmentacionService;
